import { attachmentService } from '@/services'
import { computed } from 'vue'
import { useStore } from 'vuex'
import AWS from 'aws-sdk'

export default (props) => {
  const { state, commit, getters, dispatch } = useStore()

  const share = computed(() => state.project.share)
  const allowAddAttachments = computed(() => getters.allowAddAttachments)

  async function uploadToS3 (file) {
    const projectId = props.project?.id
    const taskId = props.task?.id
    const discussionId = props.discussion?.id

    AWS.config.update({
      region: 'eu-central-1',
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'eu-central-1:6c25ba0f-af55-402a-896a-c52812ec3398'
      })
    })

    var s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      params: { Bucket: process.env.VUE_APP_AWS_BUCKET }
    })

    const options = {
      projectId: projectId,
      taskId: taskId,
      discussionId: discussionId,
      shareId: share.value?.id,
      mimeType: file.type || 'application/octet-stream',
      size: file.size,
      name: file.name
    }
    const methodName = props.isShared ? 'createFileShared' : 'createFile'

    const uploadedFile = await attachmentService[methodName](options)

    commit('setFile', { id: uploadedFile.data.id, percent: 1, bookId: props.bookId })

    const request = s3.putObject({
      Key: uploadedFile.data.key,
      Body: file,
      ACL: 'public-read'
    })
      .on('httpUploadProgress', (evt) => {
        commit('setFile', {
          id: uploadedFile.data.id,
          percent: parseInt((evt.loaded * 100) / evt.total) || 1,
          bookId: props.bookId,
          abort: () => setTimeout(() => request.abort(), 50)
        })
      })

    const url = `https://${process.env.VUE_APP_AWS_BUCKET}.s3.eu-central-1.amazonaws.com/${uploadedFile.data.key}`

    request.promise()
      .then(() => {
        commit('setFile', { id: uploadedFile.data.id, percent: -1, bookId: props.bookId })

        const method = props.isShared ? 'updateFileShared' : 'updateFile'

        attachmentService[method]({
          id: uploadedFile.data.id,
          shareId: share.value.id,
          projectId: projectId,
          taskId: taskId,
          discussionId: discussionId,
          url: url
        })
      }).catch(() => {})

    return {
      id: uploadedFile.data.id,
      name: file.name,
      size: file.size
    }
  }

  function uploadImage (file) {
    commit('loading', true)

    if (props.isShared) {
      const formData = new FormData()
      formData.append('data', file)

      return attachmentService.uploadShared(props.project.id, share.value.id, formData)
        .then(response => {
          return {
            url: response.data.url,
            id: response.data.id,
            name: file.name,
            size: file.size
          }
        })
    } else {
      if (allowAddAttachments.value(file.size)) {
        const formData = new FormData()
        formData.append('data', file)

        return attachmentService.upload({
          projectId: props.project?.id,
          taskId: props.task?.id,
          discussionId: props.discussion?.id,
          data: formData
        })
          .then(response => {
            dispatch('stats')
            return {
              url: response.data.url,
              id: response.data.id,
              name: file.name,
              size: file.size
            }
          })
      } else {
        commit('toggleLimitModal', { show: true, type: 'File uploads' })
        commit('loading', false)
      }
    }
  }

  function upload (file) {
    const isImages = (/image/i).test(file.type)

    if (file.size / 1024 / 1024 >= 400) {
      return commit('setNotification', { isVisible: true, message: 'File size too big, uploads up to 400MB are allowed', color: 'error' })
    }

    if (isImages) {
      return uploadImage(file)
    } else {
      return uploadToS3(file)
    }
  }

  return {
    upload
  }
}
